<template>
  <el-main class="container">
    <el-form
      label-position="top"
      label-width="80px">
      <div class="title" v-if="type === 'set'">编辑轮播图</div>
      <div class="title" v-else>新增轮播图</div>
      <el-form-item label="排序序号">
        <el-input
          placeholder="请输入排序序号"
          v-model.trim="body.indexNum"
          @mousewheel.native.prevent
          clearable
          class="width"
          type="number"/>
      </el-form-item>
      <el-form-item label="类型">
        <el-select
          class="width"
          v-model="selectStatus"
          placeholder="选择轮播图类型"
          @change="event().selectType($event)">
          <el-option
            v-for="(item,index) in BannerStatus"
            :key="index"
            :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跳转路径">
        <el-input
          placeholder="请输入跳转路径"
          v-model.trim="body.url"
          clearable
          class="width"/>
      </el-form-item>
      <el-form-item label="关联产业">
        <el-select class="width" v-model="selectIndustry" clearable placeholder="请选择产业">
          <el-option
            v-for="item in industryList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="pictureTitle">
        <UpLoadImg
          :tips="tips"
          :img="picture"
          :size="[350, 180]"
          @get-files="getFiles"/>
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <el-button @click="event().back()">取消</el-button>
      <el-button type="primary" @click="event().save()">保存</el-button>
    </div>
  </el-main>
</template>

<script>
import UpLoadImg from '@/components/upload-img'
import { addCarouse, setCarouse } from '@/api/basic'
import { getIndustrySelectList } from '@/api/industry'
export default {
  data() {
    return {
      tips: '',//提示
      type: '',
      body: {
        indexNum: '',
        picture: '',
        type: '',
        industryUuid: '',
        url: '',
      },
      picture: '',
      pictureTitle: '分类图片(0/1)',
      BannerStatus: ['停车缴费', '企业服务', '首页'],
      selectStatus: '',
      industryList: [],
      selectIndustry: ''
    }
  },
  created() {
    const { meta } = this.$route
    this.type = meta[meta.length - 1].url
    this.network().getIndustrySelectList()
  },
  mounted() {
    if (this.type === 'set') {
      this.picture = this.$route.query.info.picture
      this.selectIndustry = this.$route.query.info.industryUuid
      if (this.$route.query.info.type === 0) {
        this.selectStatus = this.BannerStatus[0]
      } else if (this.$route.query.info.type === 1) {
        this.selectStatus = this.BannerStatus[1]
      } else this.selectStatus = this.BannerStatus[2]
      Object.assign(this.body, this.$route.query.info)
    }
    this.picture ? this.pictureTitle = `分类图片(1/1)` : this.pictureTitle = `分类图片(0/1)`
  },
  methods: {
    event() {
      return {
        selectType: (e) => {
          if (e === this.BannerStatus[0]) {
            this.tips = '(686*288)';
            this.body.type = 0
          } else if (e === this.BannerStatus[1]) {
            this.tips = '(686*320)';
            this.body.type = 1
          } else {
            this.tips = '(686*278)';
            this.body.type = 2
          }
        },
        back: () => {
          this.$router.push('/basic-management/carousel')
        },
        save: () => {
          this.body.industryUuid = this.selectIndustry
          if (!this.handlerVarifyBody()) return
          if (this.type === 'set') {
            this.network().setCarouse()
          } else {
            this.network().addCarouse()
          }
        }
      }
    },
    network() {
      return {
        setCarouse: async() => {
          await setCarouse(this.body)
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.event().back()
        },
        addCarouse: async() => {
          await addCarouse(this.body)
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.event().back()
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        }
      }
    },
    handlerVarifyBody() {
      if (!this.body.indexNum) {
        this.$message({
          message: '请填写序列号',
          type: 'error'
        })
        return false
      }
      if (this.body.type === '') {
        this.$message({
          message: '请选择分类',
          type: 'error'
        })
        return false
      }
      if (this.body.industryUuid === '') {
        this.$message({
          message: '请选择关联产业',
          type: 'error'
        })
        return false
      }
      if (this.body.url === '') {
        this.$message({
          message: '请输入跳转路径',
          type: 'error'
        })
        return false
      }
      if (!this.body.picture) {
        this.$message({
          message: '请上传图片',
          type: 'error'
        })
        return false
      }
      return true
    },
    getFiles(file, files) {
      this.body.picture = files.length ? file.response : ''
      this.body.picture ? this.pictureTitle = `分类图片(1/1)` : this.pictureTitle = `分类图片(0/1)`
    }
  },
  components: {
    UpLoadImg
  }
}
</script>

<style scoped lang="scss">
.container{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .title{
    font-weight: bold;
    margin: 15px 0;
    font-size: 20px
  }
  .btn-box{
    display: flex;
    justify-content: center;
    button{
      margin: 0 15px;
    }
  }
  .width{
    width: 400px;
  }

  // .img-box{
  //   display: inline-block;
  //   text-align: center;
  //   .tips {
  //     color: #999;
  //   }
  // }
}
</style>
